import React from 'react';
import { Search, Filter } from 'lucide-react';

const GroupeFilters = ({ filters, onFilterChange }) => {
  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Recherche */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Rechercher un groupe..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        {/* Filtre par région */}
        <div className="relative">
          <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Filtrer par région..."
            value={filters.region}
            onChange={(e) => onFilterChange('region', e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        {/* Tri */}
        <select
          value={filters.ordering}
          onChange={(e) => onFilterChange('ordering', e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
        >
          <option value="-id">Plus récents</option>
          <option value="id">Plus anciens</option>
          <option value="titre">Titre (A-Z)</option>
          <option value="-titre">Titre (Z-A)</option>
        </select>
      </div>
    </div>
  );
};

export default GroupeFilters;
